import { render, staticRenderFns } from "./Landing5Testimonials.vue?vue&type=template&id=487d43d0&scoped=true&"
import script from "./Landing5Testimonials.vue?vue&type=script&lang=js&"
export * from "./Landing5Testimonials.vue?vue&type=script&lang=js&"
import style0 from "./Landing5Testimonials.vue?vue&type=style&index=0&id=487d43d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d43d0",
  null
  
)

export default component.exports